export type ConsentCategories = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
};

const STORAGE_KEY = "fm_consent_v1";
const EVENT_NAME = "fm:consent-changed";
const OPEN_EVENT = "fm:open-cookie-settings";

export function getConsent(): ConsentCategories | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { necessary: true, analytics: !!parsed.analytics, marketing: !!parsed.marketing };
  } catch {
    return null;
  }
}

export function saveConsent(c: Omit<ConsentCategories, "necessary">) {
  const value: ConsentCategories = { necessary: true, analytics: c.analytics, marketing: c.marketing };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    /* ignore */
  }
  pushToGtm(value);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: value }));
}

function pushToGtm(c: ConsentCategories) {
  const w = window as unknown as {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };
  w.dataLayer = w.dataLayer || [];
  // Consent Mode v2 update
  w.dataLayer.push([
    "consent",
    "update",
    {
      ad_storage: c.marketing ? "granted" : "denied",
      ad_user_data: c.marketing ? "granted" : "denied",
      ad_personalization: c.marketing ? "granted" : "denied",
      analytics_storage: c.analytics ? "granted" : "denied",
    },
  ]);
  // Custom event for GTM triggers
  w.dataLayer.push({
    event: "consent_update",
    consent: { analytics: c.analytics, marketing: c.marketing },
  });
}

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export const CONSENT_EVENT = EVENT_NAME;
export const OPEN_SETTINGS_EVENT = OPEN_EVENT;
